import { t } from "@/i18n-js/instance";
import type { ButtonProps } from "@circle-react-uikit/Button";
import { Button } from "@circle-react-uikit/Button";

export interface ButtonWithDisabledProps extends ButtonProps {
  classNames?: string;
  isDisabled?: boolean;
  submitting?: boolean;
  submittingText?: string;
}

export const ButtonWithDisabled = ({
  type = "button",
  classNames = "",
  children,
  submitting = false,
  submittingText = t("submitting"),
  isDisabled = false,
  ...rest
}: ButtonWithDisabledProps) => (
  <Button
    type={type}
    disabled={submitting || isDisabled}
    {...rest}
    className={classNames}
  >
    {submitting && submittingText}
    {!submitting && children}
  </Button>
);
